<img alt="Airbus logo" src="assets/img/Airbus_logo_2017.png" />
@if (errorMessage) {
  <h2>{{ errorMessage }}</h2>
} @else {
  <h1>{{ defaultMessage }}</h1>
}
